module.exports = __webpack_public_path__ + "img/ori_img_4.d718632c.png";